import {
  CtrlType,
  CtrlProps
} from "@yuigoto/ctrl";

/**
 * @type {CtrlProps[]}
 */
export const GenericAddressControl = [
  {
    name: "postalCode",
    label: "CEP",
    type: CtrlType.CEP,
    required: true,
    requiredMessage: "Campo obrigatório"
  },
  {
    name: "stateCode",
    label: "UF",
    type: CtrlType.DROPDOWN,
    options: [
      {
        "value": 12,
        "name": "Acre"
      },
      {
        "value": 27,
        "name": "Alagoas"
      },
      {
        "value": 16,
        "name": "Amapá"
      },
      {
        "value": 13,
        "name": "Amazonas"
      },
      {
        "value": 29,
        "name": "Bahia"
      },
      {
        "value": 23,
        "name": "Ceará"
      },
      {
        "value": 53,
        "name": "Distrito Federal"
      },
      {
        "value": 32,
        "name": "Espírito Santo"
      },
      {
        "value": 52,
        "name": "Goiás"
      },
      {
        "value": 21,
        "name": "Maranhão"
      },
      {
        "value": 51,
        "name": "Mato Grosso"
      },
      {
        "value": 50,
        "name": "Mato Grosso do Sul"
      },
      {
        "value": 31,
        "name": "Minas Gerais"
      },
      {
        "value": 15,
        "name": "Pará"
      },
      {
        "value": 25,
        "name": "Paraíba"
      },
      {
        "value": 41,
        "name": "Paraná"
      },
      {
        "value": 26,
        "name": "Pernambuco"
      },
      {
        "value": 22,
        "name": "Piauí"
      },
      {
        "value": 33,
        "name": "Rio de Janeiro"
      },
      {
        "value": 24,
        "name": "Rio Grande do Norte"
      },
      {
        "value": 43,
        "name": "Rio Grande do Sul"
      },
      {
        "value": 11,
        "name": "Rondônia"
      },
      {
        "value": 14,
        "name": "Roraima"
      },
      {
        "value": 42,
        "name": "Santa Catarina"
      },
      {
        "value": 35,
        "name": "São Paulo"
      },
      {
        "value": 28,
        "name": "Sergipe"
      },
      {
        "value": 17,
        "name": "Tocantins"
      }
    ],
    required: true,
    requiredMessage: "Campo obrigatório"
  },
  {
    name: "city",
    label: "Cidade",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Campo obrigatório"
  },
  {
    name: "streetNeighborhood",
    label: "Bairro",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Campo obrigatório"
  },
  {
    name: "street",
    label: "Endereço",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Campo obrigatório"
  },
  {
    name: "streetNumber",
    label: "Número",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Campo obrigatório"
  },
  {
    name: "streetExtension",
    label: "Complemento",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Campo obrigatório"
  }
];
